interface Props {
    borderColor?: string;
    bgColor?: string;
    textColor?: string;
    text: string;
    size?: "sm" | "normal";
}

export function TextChip({ borderColor, bgColor, textColor, text, size = "normal" }: Props) {
    const defaultBorderColor = borderColor ?? "border-gray-700";
    const defaultBgColor = bgColor ?? "bg-gray-200";
    const defaultTextColor = textColor ?? "text-gray-700";

    return (
        <span style={{ borderWidth: "1px" }} className={`${size == "sm" ? "text-sm px-2" : "px-3"} text-center rounded-xl font-semibold ${defaultBorderColor} ${defaultBgColor} ${defaultTextColor}`}>
            {text}
        </span>
    );
}
